<template>
  <div class="data-tabs">
    <el-row :span="24">
      <el-col :md="span"
              :xs="24"
              :sm="12"
              v-for="(item,index) in data"
              :key="index">
        <div class="item" :style="{background:item.color}">
          <div class="item-header">
              <p style="color: rgba(96,98,102,1);font-size: 12px;">{{item.title}}</p>
              <span  style="color: rgba(191,194,204,1);font-size: 12px;">{{item.subtitle}}</span>
            </div>
            <div class="item-body">
              <h2  style="color: rgba(179,48,70,1);font-size: 42px;padding-left: 4px;">
                {{item.count}}
                <span v-html="item.unit"  style="color: rgba(179,48,70,1);font-size: 12px;"></span>
              </h2>
            </div>
            <div class="item-footer" style="border-top:1px solid #F5F7FA">
              <p  style="color: rgba(191,194,204,1);font-size: 12px;">{{item.text}}</p>
            </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: 'data-tab',
  data () {
    return {

    };
  },
  computed: {
    span () {
      return this.option.span || 8;
    },
    data () {
      return this.option.data || [];
    }
  },
  props: {
    option: {
      type: Object,
      default: () => { }
    }
  }
};
</script>
